import LeadAcquisition from './LeadAcquisition';
export default LeadAcquisition;
